import { Link } from "react-router-dom";
import { scrollTo } from "@/lib/api";
import { SocialLinks } from "@/components/site/SocialLinks";
import { ShareBar } from "@/components/site/ShareBar";

export const Footer = () => (
  <footer className="px-6 md:px-16 pt-16 pb-10" data-testid="site-footer">
    <div className="gold-line mb-12" />
    <div className="flex flex-col md:flex-row justify-between gap-8">
      <div>
        <p className="font-display gold-text text-2xl">Earth Angel</p>
        <p className="font-cinzel text-sm mt-2 text-[#f7f1e1]/80">The Chosen Star Seed Healer and Teacher</p>
        <p className="italic text-[#f1d57a] mt-4">"Transmute pain into purpose"</p>
        <div className="mt-8"><SocialLinks /></div>
        <div className="mt-8"><ShareBar /></div>
      </div>
      <div className="flex flex-wrap gap-4 items-start">
        <button className="btn-ghost !py-2.5 !px-6 !text-xs" onClick={() => scrollTo("group")} data-testid="footer-group-btn">Group Sessions</button>
        <button className="btn-gold !py-2.5 !px-6 !text-xs" onClick={() => scrollTo("request")} data-testid="footer-request-btn">Request a Session</button>
      </div>
    </div>
    <div className="mt-12 flex flex-wrap justify-between gap-4 text-xs text-[#f7f1e1]/50">
      <span>© 2026 Queen Boyce · earthangelstarseed.com</span>
      <Link to="/owner" className="hover:text-[#d4af37] transition-colors" data-testid="footer-owner-link">Owner</Link>
    </div>
  </footer>
);
